module.exports = __webpack_public_path__ + "static/media/emoji_friends.ce9fd2b3.svg";